import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IVariablesClient, VariablesClient } from "app/ApiClient";
import { IState } from "slices";
import { LoadingState } from "types";
import { initialBrandsState } from "./brandsState";

const variablesClient: IVariablesClient = new VariablesClient(process.env.REACT_APP_API_URL);

export const getBrands = createAsyncThunk(
  "brands/getBrands",
  async (
    { projectId, versionId, assigner }: { projectId: number; versionId: string; assigner: string },
    { rejectWithValue },
  ) => {
    try {
      const result = await variablesClient.getBrands(projectId, versionId, assigner);
      return result;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

const brandsSlice = createSlice({
  name: "brands",
  initialState: initialBrandsState,
  reducers: {
    resetBrands: () => initialBrandsState,
  },
  extraReducers: (builder) => {
    // getBrands
    builder.addCase(getBrands.pending, (state) => {
      state.brands = [];
      state.loading = LoadingState.pending;
    });
    builder.addCase(getBrands.fulfilled, (state, { payload }) => {
      state.brands = payload || [];
      state.loading = LoadingState.succeed;
    });
    builder.addCase(getBrands.rejected, (state) => {
      state.brands = [];
      state.loading = LoadingState.failed;
    });
  },
});
export const { resetBrands } = brandsSlice.actions;
export const brandsSelector = (state: IState) => state.brands;
export default brandsSlice.reducer;
